import { Reducer } from 'redux';
import produce from 'immer';

import { defaultThemeState, ThemeState } from './states';
import { ThemeActions } from './actions';

const themeReducer: Reducer<ThemeState, ThemeActions> = (
  state = defaultThemeState,
  action
) =>
  produce(state, (draft) => {
    switch (action.type) {
      case 'theme/change':
        draft.theme = action.theme;
        return;
    }
  });

export default themeReducer;
